import React, { useEffect, useState } from "react";
import Header from "../components/Layout/Header";
import Footer from "../components/Layout/Footer";
import ProductDetails from "../components/Products/ProductDetails";
import { useParams, useSearchParams } from "react-router-dom";
import SuggestedProduct from "../components/Products/SuggestedProduct";
import { useSelector } from "react-redux";
import axios from "axios";
import { server } from "../server";

const ProductDetailsPage = () => {
  const { allProducts } = useSelector((state) => state.products);
  const { allEvents } = useSelector((state) => state.events);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const eventData = searchParams.get("isEvent");

  useEffect(() => {
    window.scrollTo(0, 0);

    if (eventData !== null) {
      const eventItem = allEvents && allEvents.find((i) => i._id === id);
      setData(eventItem || null);
      setLoading(false);
      return;
    }

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data: res } = await axios.get(`${server}/product/get-product/${id}`);
        if (!cancelled) {
          setData(res?.product || null);
        }
      } catch {
        const fallback = allProducts && allProducts.find((i) => i._id === id);
        if (!cancelled) {
          setData(fallback || null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [id, eventData, allProducts, allEvents]);

  return (
    <div>
      <Header />
      {loading ? (
        <div className="w-full flex justify-center py-16 text-slate-500">Loading product...</div>
      ) : data ? (
        <ProductDetails data={data} />
      ) : (
        <div className="w-full flex justify-center py-16 text-slate-500">Product not found.</div>
      )}
      {!eventData && data ? <SuggestedProduct data={data} /> : null}
      <Footer />
    </div>
  );
};

export default ProductDetailsPage;
